export default __webpack_public_path__ + "static/media/Decathlon.24e9b42e.jpeg";